import React from "react";
import "../../App.css";
import CardGrid from "../CardGrid.js";

export default function Home() {
  return (
    <div className="home">
      <CardGrid />

      <div
        style={{
          position: "fixed",
          bottom: "24px",
          right: "20px",
          fontSize: "14px",
          color: "#ccc",
        }}
      >
        <span style={{ color: "#302b2b" }}>Powered by </span>
        <a
          href="https://techiteasy.co.in/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#2f3654",
            textDecoration: "none",
            fontWeight: 500,
          }}
          onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
          onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
        >
          Tech It Easy
        </a>
      </div>
    </div>
  );
}
